import { EFeatureFlags, FeatureFlagConfigs } from './featureFlags';

export enum EMetricsRegistry {
  NetOee = 'netOee',
  Annotation = 'annotation',
  NetAvailability = 'netAvailability',
  TargetAvailability = 'targetAvailability',
  CurrentAvailability = 'currentAvailability',
  PreviousAvailability = 'previousAvailability',
  AverageAvailabilityByWeekDay = 'averageAvailabilityByWeekDay',
  AverageAvailabilityByWeekNight = 'averageAvailabilityByWeekNight',
  AverageAvailabilityByWeekMorning = 'averageAvailabilityByWeekMorning',
  AverageAvailabilityByWeekAfternoon = 'averageAvailabilityByWeekAfternoon',
  OeeOee = 'oee_oee',
  OeeQuality = 'oee_quality',
  OeeProduced = 'oee_produced',
  OeeEffectiveness = 'oee_effectiveness',
  TotalPerformance = 'total_performance',
  TotalOee = 'total_oee',
  IdealProduction = 'idealProduction',
  IdealSpeedProduction = 'idealSpeedProduction'
}

export enum EMachineConfigUIViewType {
  TvKpi = 'tvKpi',
  DesktopNonKpi = 'desktopNonKpi',
  TvSingleMachine = 'tvSingleMachine',
  TvTowerView2x2 = 'tvTowerView2x2',
  TvTowerView3x3 = 'tvTowerView3x3',
  TvTowerView6x3 = 'tvTowerView6x3',
  TvTowerViewOperator = 'tvControlOperatorView'
}

export enum ETvModeLayout {
  Single = 'single',
  Grid2x2 = 'grid2x2',
  Grid3x3 = 'grid3x3',
  Grid6x3 = 'grid6x3',
  Grid4x8 = 'grid4x8',
  OperatorView = 'tvControlOperatorView',
  OperatorSingleView = 'tvControlOperatorSingleView'
}
export type MachineConfigUIProductionTypeEnum =
  | 'total'
  | 'correct'
  | 'defects'
  | 'idealProduction'
  | 'idealSpeedProduction';
export type MachineConfigUICountSensorEnum =
  | 'accumulatedCount'
  | 'currentMinuteCount'
  | 'sensors_oee'
  | 'sensors_instantaneous_velocity'
  | 'sensors_avg_velocity'
  | 'sensors_aggregated_production'
  | 'hourByHourDefects'
  | 'hourByHourProducts'
  | 'hourByHourTargets'
  | 'hourByHourPerformance'
  | 'skipHourlyProration';
export type MachineConfigUIProductionBasicAndProdFullEnum =
  | MachineConfigUIProductionTypeEnum
  | 'currentMinuteCount'
  | 'instantaneous_velocity'
  | 'avg_velocity'
  | 'scrap';
export type MachineConfigUIAvailabilityEnum =
  | 'availability'
  | 'annotation'
  | 'netAvailability'
  | 'targetAvailability'
  | 'previousAvailability'
  | 'currentAvailability'
  | 'averageAvailabilityByWeekAfternoon'
  | 'averageAvailabilityByWeekDay'
  | 'averageAvailabilityByWeekMorning'
  | 'averageAvailabilityByWeekNight'
  | 'averageAvailabilityForDays'
  | 'stops'
  | 'uptime'
  | 'downtime'
  | 'plannedDowntime'
  | 'unplannedDowntime';
export type MachineConfigUIProductionsEnum =
  | 'oee_quality'
  | 'oee_produced'
  | 'oee_effectiveness'
  | 'total_performance'
  | 'total_oee'
  | 'oee_oee'
  | 'netOee';
export type MachineConfigUICycleEnum =
  | 'instantaneousCycleSpeed'
  | 'instantaneousCycleTime'
  | 'instantaneousCycleCount';
export type MachineConfigUIEnergyEnum = 'energy';
export type MachineConfigUIProductCountEnum = 'productCount';
export type MachineConfigUIVibrationEnum =
  | 'vibrationDisplacementX'
  | 'vibrationDisplacementY'
  | 'vibrationDisplacementZ'
  | 'vibrationVelocityX'
  | 'vibrationVelocityY'
  | 'vibrationVelocityZ'
  | 'vibrationAccelerationX'
  | 'vibrationAccelerationY'
  | 'vibrationAccelerationZ';
export type MachineConfigUITemperatureEnum = 'temperature';
export type MachineConfigUIPressureEnum =
  | 'pressureLeftPresizeAdjustNut'
  | 'pressureRightPresizeAdjustNut';
export type MachineConfigUIMetricEnum =
  | MachineConfigUICountSensorEnum
  | MachineConfigUIProductionBasicAndProdFullEnum
  | MachineConfigUIAvailabilityEnum
  | MachineConfigUIProductionsEnum
  | MachineConfigUICycleEnum
  | MachineConfigUIEnergyEnum
  | MachineConfigUIProductCountEnum
  | MachineConfigUIVibrationEnum
  | MachineConfigUITemperatureEnum
  | MachineConfigUIPressureEnum;

export enum EUnorderedMetricEnum {
  HourByHourDefects = 'hourByHourDefects',
  HourByHourProducts = 'hourByHourProducts',
  HourByHourTargets = 'hourByHourTargets',
  HourByHourPerformance = 'hourByHourPerformance',
  SkipHourlyProration = 'skipHourlyProration'
}

export enum EFeatureFlagComparison {
  Or = 'or',
  And = 'and'
}

export type MachineConfigUIParameter = {
  name: string;
  type: 'number' | 'option';
  unit?: string;
  options?: string[];
  min?: number;
  max?: number;
  value?: string | number;
};

export type MachineConfigUIMetricContent = {
  metric: MachineConfigUIMetricEnum;
  enabled: boolean;
  order: number;
  parameters?: MachineConfigUIParameter[];
  featureFlagRequired?: EFeatureFlags[];
};

export type MachineConfigUICatalogContent = {
  machines?: number[];
  viewType: EMachineConfigUIViewType[];
  parameters?: MachineConfigUIParameter[];
  comparison: EFeatureFlagComparison;
} & (
  | {
      comparison: EFeatureFlagComparison.Or;
      featureFlagRequired?: EFeatureFlags[];
    }
  | {
      comparison: EFeatureFlagComparison.And;
      featureFlagRequired?: EFeatureFlags[][];
    }
);

export type MachineConfigUICatalog = {
  [metricEnum in MachineConfigUIMetricEnum]: MachineConfigUICatalogContent;
};

export type ConfigValue =
  | {
      [key: string]: ConfigValue;
    }
  | (string | boolean | null | number);

type SPCConfig = {
  OEE: boolean;
  legacyOEE: boolean;
  legacyMetrics: boolean;
};

type IntegrationConfig = {
  OEE: boolean;
  legacyOEE: boolean;
  localtime: boolean;
  overrides: { speeds: boolean; targets: boolean; workLogs: boolean };
  dateFormat: string;
};

type ProductionConfig = {
  enabled: boolean;
  scrapEnabled: boolean;
  aceromexExclusiveFeatures: boolean;
  estimatedDeliveryTimeEnabled: boolean;
};

type GridConfig = {
  rows: number;
  columns: number;
};

type UnknownMetrics = Record<string, ConfigValue>;
type KnownMetrics = Record<EMetricsRegistry, ConfigValue>;

export type Metrics = Partial<KnownMetrics & UnknownMetrics>;

export type RealtimeConfig = {
  metrics: Metrics;
  realtimeNonKpi: Metrics;
  showOeeMetrics: boolean;
};

export type UserConfig = {
  spc: SPCConfig;
  logo: string;
  work: { unitA: number };
  showDSO: boolean;
  isEquity: boolean;
  realtime?: RealtimeConfig;
  integrations: IntegrationConfig;
  production: ProductionConfig;
  showVotings: boolean;
  smsQuota: number;
  background: string;
  /**
   * @deprecated but still supported
   */
  kpisTvMode: GridConfig;
  /**
   * @deprecated
   */
  legacyTvMode: GridConfig;
  shiftSettings: {
    allowEditionUpToDays: number;
    moveNightToNextDay: boolean;
  };
  /**
   * Company-specific allowlist of selectable shift titles (e.g. Carrier
   * excludes "Morning"). Absent/empty falls back to the full static list.
   */
  shiftTitles?: string[];
  showDividends: boolean;
  smsQuotaStart: Date;
  backgroundColor: string;
  showInnerTrading: boolean;
  lavados: { enabled: boolean };
  featureFlags: FeatureFlagConfigs;
  machineMetricCatalog: MachineConfigUICatalog;
  machineMetricConfig: {
    [machineId: string]: {
      [viewType in EMachineConfigUIViewType]: MachineConfigUIMetricContent[];
    };
  };
  tvGridMode?: {
    mode: ETvModeLayout;
  };
  tvModeTimerSeconds?: number;
  /**
   * Controls whether TV-mode status bars show elapsed time since the last
   * status change, the clock time of that change, or both.
   */
  tvModeStatusTimeDisplay?: TvModeStatusTimeDisplay;
  /**
   * When true, TV Mode omits machines whose realtime state is `NO_SHIFT` or
   * `OUT_OF_SHIFT` so only in-shift machines appear in the carousel/grid.
   * Defaults to false (show all selected machines).
   */
  tvModeHideOutOfShiftMachines?: boolean;
  /**
   * Per-layout configuration of which non-metric "tags" (operator, SKU, SKU
   * description, stop cause) TV-mode cards display. Keyed by the same
   * `EMachineConfigUIViewType` used by `machineMetricConfig`. Optional/partial:
   * any view without an entry falls back to `DEFAULT_TV_MODE_DISPLAY_OPTIONS`,
   * which reproduces the original hardcoded behavior.
   */
  tvModeDisplayOptions?: TvModeDisplayOptions;
};

/** How the stop cause is shown on a TV-mode card. */
export type StopCauseDisplay =
  | 'none'
  | 'general'
  | 'generalAndSpecific'
  | 'specific';

/** How the status-bar time is shown on TV-mode cards. */
export type TvModeStatusTimeDisplay = 'elapsed' | 'changeTime' | 'both';

/**
 * The set of non-metric tags a TV-mode layout with one shared config
 * displays. Used by the Single-machine and 2x2 layouts, whose card shows
 * the same tags regardless of machine state.
 */
export type TvModeCardDisplayOptions = {
  showOperator: boolean;
  showSku: boolean;
  showSkuDescription: boolean;
  stopCause: StopCauseDisplay;
};

/**
 * Machine-state bucket for layouts that configure their card tags
 * separately per state. `producing` covers Producing + No-data; `stopped`
 * covers Alert + Stopped.
 */
export type TvModeCardStateGroup = 'producing' | 'stopped';

/**
 * Per-state toggle tags for the 3x3 layout. The Alert/Stopped bucket caps
 * the number of enabled tags at 2 in the settings UI; the type itself does
 * not enforce that.
 */
export type TvModeStateToggleOptions = {
  showOperator: boolean;
  showSku: boolean;
  showSkuDescription: boolean;
  showGeneralCause: boolean;
  showSpecificCause: boolean;
};
export type TvModeGrid3x3DisplayOptions = Record<
  TvModeCardStateGroup,
  TvModeStateToggleOptions
> & {
  /**
   * Whether the 3x3 card shows the per-machine real-time production/downtime
   * bar. Unlike the per-state tag toggles, this applies to the
   * card regardless of machine state.
   */
  showRealTimeBar: boolean;
};

/**
 * Per-state single-choice tag for the 6x3 layout. Its status bar hosts
 * exactly one tag, so each state picks a single value.
 */
export type TvModeProducingTag = 'sku' | 'skuDescription' | 'operator';
export type TvModeStoppedTag =
  | 'sku'
  | 'skuDescription'
  | 'generalCause'
  | 'specificCause';
export type TvModeGrid6x3DisplayOptions = {
  producing: TvModeProducingTag;
  stopped: TvModeStoppedTag;
};

/**
 * Per-layout display options, keyed by view type. Single machine and 2x2
 * use one shared config; 3x3 and 6x3 configure their tags per machine
 * state. All entries optional — a missing entry falls back to the layout's
 * default in `DEFAULT_TV_MODE_DISPLAY_OPTIONS`.
 */
export type TvModeDisplayOptions = {
  [EMachineConfigUIViewType.TvSingleMachine]?: TvModeCardDisplayOptions;
  [EMachineConfigUIViewType.TvTowerView2x2]?: TvModeCardDisplayOptions;
  [EMachineConfigUIViewType.TvTowerView3x3]?: TvModeGrid3x3DisplayOptions;
  [EMachineConfigUIViewType.TvTowerView6x3]?: TvModeGrid6x3DisplayOptions;
  [EMachineConfigUIViewType.TvTowerViewOperator]?: TvModeCardDisplayOptions;
  [EMachineConfigUIViewType.TvKpi]?: TvModeCardDisplayOptions;
  [EMachineConfigUIViewType.DesktopNonKpi]?: TvModeCardDisplayOptions;
};

// this is mostly just an alias
export type UIMetric = Omit<
  MachineConfigUIMetricContent,
  'featureFlagRequired'
>;

export type MachinePlotMetricType =
  | 'current'
  | 'total'
  | 'correct'
  | 'defects'
  | 'cycle_time'
  | 'cycle_count'
  | 'cycle_speed'
  | 'energy'
  | 'product_count'
  | 'vibration_displacement_x'
  | 'vibration_displacement_y'
  | 'vibration_displacement_z'
  | 'vibration_velocity_x'
  | 'vibration_velocity_y'
  | 'vibration_velocity_z'
  | 'vibration_acceleration_x'
  | 'vibration_acceleration_y'
  | 'vibration_acceleration_z'
  | 'temperature'
  | 'pressure_left_presize_adjust_nut'
  | 'pressure_right_presize_adjust_nut';
